import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

/**
 * Relationship classes
 */
export class EducationLevelAttributes {
  id: string = null;
  title: string = null;
  eceRelated?: boolean = null;
  filterableEducationLevel: string = null;
}

export class EducationLevelBelongsTo {}
export class EducationLevelHasOne {}
export class EducationLevelHasMany {}

/**
 * Utility interfaces
 */
export interface EducationLevelMethods {}

export interface EducationLevelInterface extends EducationLevelAttributes, EducationLevelType {}

type EducationLevelType = GConstructor<EducationLevelInterface>;

export interface EducationLevelResource
  extends Base<EducationLevelAttributes>,
    EducationLevelInterface,
    EducationLevelMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EducationLevelAttributes>({
    queryName: 'education_levels',
    className: 'EducationLevel',
    AttributesClass: EducationLevelAttributes,
  });

export const EducationLevelResourceClass = <TBase extends EducationLevelType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements EducationLevelMethods {};

export class EducationLevelResource extends ClassExtender<EducationLevelInterface>(
  BaseClass,
  EducationLevelResourceClass,
) {}

/**
 * Resource instance
 */
export const EducationLevel =
  APILibrary.createResource<EducationLevelResource>(EducationLevelResource);
